<template>
<div>
  <div
    class="contentblock board_layout"
    :data-block-id="bdata.paperBlockId"
  >
    <div
      class="eidtbox-ty1 content_line">
      <div class="row_box clear hover_box">
        <!-- [rowbox] -->
        <div class="hover_inner">
          <!-- [드래그 핸들] -->
          <!-- 보이는 드래그 핸들 -->
          <div class="move"></div>
          <!-- 실제 이벤트 드래그 핸들 -->
          <div class="block_handle" ref="dragHandle"
            :data-block-id="bdata.paperBlockId"
            :transfer-data="bdata.paperBlockId"
            @mousedown="dragBlockState(1)"
            @mouseup="dragBlockState(0)"
            @touchstart="dragBlockState(1)"
            @touchend="dragBlockState(0)">
            &nbsp;
          </div>
          <!-- /[드래그 핸들] -->
          <div>
            <!-- [구분선 블럭] -->
            <hr :class="state.focused ? 'focused' : ''"/>
          </div>
          <!-- [의견 영역] -->
        </div>
        <!-- /[rowbox] -->
      </div>
    </div>
  </div>
</div>
</template>
<script>
export default {
  props: {
    paperInfo: Object,
    blockInfo: Object,
    boardMemberInfo: Object,
    boardSection: Array,
    bdata: Object,
    transmitter: Object,
    userInfo: Object,
    paperBlockIdList: Array,
    paperBlockMap: Object,
    boardUtil: Object,
    context: Object,
    memberSelector: Object,
  },
  data() {
    return {
      pdata: this.bdata,
      editable: false,
      keepInBounds: true,
      messageList: [],
      files: [],
      fileUploadType: null,
      state: { focused: false },
      userList: [],
      members: this.boardMemberInfo.userList,
    };
  },
  created() {
    this.context.eventBusProc(this);
    this.context.initContentBlock(this);
  },
  mounted() {
    let self = this;
    this.renderCompleted(function(){
      self.$emit("blockMatch");
    });
  },
  watch: {
    "state.focused": {
      handler() { }
    },
  },
  beforeDestroy() {
    delete this.transmitter.subscribers[this.bdata.paperBlockId];
  },
  methods: { },
}
</script>

<!-- 지역스타일 지정 -->
<style scoped>
hr {
  border-top: 1px solid #d3d4d6;
}
hr.focused {
  border-top: 1px solid #000;
}
</style>


// WEBPACK FOOTER //
// src/components/cowork/general/board/editor/ContentBlockTypeLine.vue